import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { StickyMobileCTA } from "./components/StickyMobileCTA";
import { BackToTop } from "./components/BackToTop";
import { Preloader } from "./components/Preloader";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import { Hero } from "./sections/Hero";
import { GoldMarquee } from "./sections/GoldMarquee";
import { Story } from "./sections/Story";
import { WhatWeDo } from "./sections/WhatWeDo";
import { HowItWorks } from "./sections/HowItWorks";
import { TrustBank } from "./sections/TrustBank";
import { Pricing } from "./sections/Pricing";
import { WhoWeServe } from "./sections/WhoWeServe";
import { Testimonials } from "./sections/Testimonials";
import { HaveTrust } from "./sections/HaveTrust";
import { FAQ } from "./sections/FAQ";
import { Contact } from "./sections/Contact";
import { FinalCTA } from "./sections/FinalCTA";
import { Footer } from "./sections/Footer";

function Home() {
  const [introDone, setIntroDone] = useState(false);
  const handleDone = useCallback(() => setIntroDone(true), []);

  return (
    <div className="bg-ink min-h-screen antialiased">
      <Preloader onDone={handleDone} />
      <Navbar />
      <main>
        <Hero introDone={introDone} />
        <GoldMarquee />
        <Story />
        <WhatWeDo />
        <HowItWorks />
        <TrustBank />
        <Pricing />
        <WhoWeServe />
        <Testimonials />
        <HaveTrust />
        <FAQ />
        <FinalCTA />
        <Contact />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
      </Routes>
      <BackToTop />
    </BrowserRouter>
  );
}

export default App;
